document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.copy--result--link').forEach(function(element) {
        element.addEventListener('click', function() {
            const parentItem = this.closest('.results--item');
            if (parentItem) {
                let currentUrl = window.location.href;
                if (currentUrl.includes('#')) {
                    currentUrl = currentUrl.split('#')[0];
                }
                const urlToCopy = currentUrl + '#' + parentItem.id;
                navigator.clipboard.writeText(urlToCopy);
            }
        });
    });


    // const rightPanels = document.querySelectorAll('.results--item .right');
    
    // rightPanels.forEach(panel => {
    //     panel.addEventListener('click', function() {
    //         this.classList.toggle('open');
    //     });
    // });

    // const button = document.querySelector('.accordion-button');
    // const content = document.querySelector('.accordion-content');

    // button.addEventListener('click', function() {
    //     if (content.style.maxHeight) {
    //         content.style.maxHeight = null;
    //     } else {
    //         content.style.maxHeight = content.scrollHeight + 'px';
    //     }
    // });
    
});
